import {
  Box,
  Button,
  Divider,
  Grid2,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ComStrengthDrilledCoreDetails = ({
  addTestHandle,
  eachTest,
  mainData,
  setMainData,
  isNonMobile,
  concreteMixtureArray,
}) => {
  // console.log("lab test data-", mainData);
  // Calculate days between two dates
  const daysDifference = useMemo(() => {
    if (!mainData.dateOfCast || !mainData.dateOfTest) return null;

    const castDate = dayjs(mainData.dateOfCast);
    const testDate = dayjs(mainData.dateOfTest);

    return testDate.diff(castDate, "day");
  }, [mainData.dateOfCast, mainData.dateOfTest]);

  const handleDateOfCast = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfCast: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const handleDateOfTest = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfTest: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  const checkFieldsHandle = () => {
    if (mainData.concreteMixture === "") {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        concreteMixture: {
          ...pre.concreteMixture,
          error: false,
        },
      }));
    }

    if (mainData.areaOfCube === "") {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        areaOfCube: {
          ...pre.areaOfCube,
          error: false,
        },
      }));
    }

    if (eachTest.weight === "") {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        weight: {
          ...pre.weight,
          error: false,
        },
      }));
    }
    if (eachTest.compressiveStrength === "") {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: true,
        },
      }));
      return;
    } else {
      setErrorCheck((pre) => ({
        ...pre,
        compressiveStrength: {
          ...pre.compressiveStrength,
          error: false,
        },
      }));
    }
    console.log("maindata", mainData);

    addTestHandle();
  };
  const handleRemoveSeleced = (deleteObj) => {
    const newArrya = mainData.labTestsDataFromSubs.filter(
      (ele) => ele.serialNo !== deleteObj
    );

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newArrya,
    }));
  };

  const handleSetWeight = (serialNo, weight) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, weight: weight } : test
      ),
    }));
  };

  const handleSetLocation = (serialNo, description) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo
          ? { ...test, description: description }
          : test
      ),
    }));
  };

  const handlesetLDRatio = (serialNo, ldRatio) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo ? { ...test, sieveSize: ldRatio } : test
      ),
    }));
  };

  const handleCompressiveStrength = (serialNo, compressiveStrength) => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((test) =>
        test.serialNo === serialNo
          ? { ...test, compressiveStrength: compressiveStrength }
          : test
      ),
    }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <div style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of cast"
              size="small"
              format="YYYY-MM-DD"
              timezone="Asia/Colombo"
              // error={errorCheck.dateOfCast.error}
              value={
                mainData.dateOfCast
                  ? dayjs(mainData.dateOfCast).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfCast(colomboTime);
              }}
            />
          </div>
        </DemoContainer>

        <DemoContainer
          alignContent="center"
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <Box style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of test"
              timezone="Asia/Colombo"
              format="YYYY-MM-DD"
              // error={errorCheck.dateOfTest.error}
              value={
                mainData.dateOfTest
                  ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfTest(colomboTime);
              }}
            />
          </Box>
        </DemoContainer>
        <Typography
          textAlign="center"
          color="success"
          variant="h4"
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          {daysDifference} Day(s)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          type="text"
          label="Cement"
          size="small"
          value={mainData.cement}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              cement: e.target.value,
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        />
        <TextField
          select
          label="Grade"
          fullWidth
          size="small"
          error={errorCheck.concreteMixture.error}
          defaultValue=""
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.concreteMixture.value}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedOption = concreteMixtureArray.find(
              (item) => item.value === selectedValue
            );
            setMainData((pre) => ({
              ...pre,
              concreteMixture: selectedOption.label,
              grade: e.target.value,
            }));
          }}
        >
          {concreteMixtureArray.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
        <TextField
          fullWidth
          variant="outlined"
          type="number"
          label="Area of Cube"
          name="areaOfCube"
          size="small"
          error={errorCheck.areaOfCube.error}
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.areaOfCube}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              areaOfCube: e.target.value,
            }))
          }
        />
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper
          variant="elevation"
          elevation={2}
          sx={{ padding: "20px", width: "100%" }}
        >
          {mainData.labTestsDataFromSubs?.map((data, index) => (
            <Grid2 container columnSpacing={0.5} key={index}>
              <Grid2 size={1} alignContent="center">
                <Typography variant="subtitle1" color="info" textAlign="center">
                  SERIAL NO
                </Typography>

                <Typography variant="h5" textAlign="center">
                  {data.serialNo === undefined
                    ? "AUTO"
                    : String(data.serialNo).padStart(3, "0")}
                </Typography>
              </Grid2>

              <Grid2 size={3} alignContent="center">
                <TextField
                  value={data.description}
                  fullWidth
                  variant="outlined"
                  label="Location"
                  onChange={(e) =>
                    handleSetLocation(data.serialNo, e.target.value)
                  }
                  size="small"
                />
              </Grid2>

              <Grid2 size={2} alignContent="center">
                <TextField
                  value={data.weight}
                  fullWidth
                  variant="outlined"
                  label="Initial Thickness"
                  onChange={(e) =>
                    handleSetWeight(data.serialNo, e.target.value)
                  }
                  type="number"
                  size="small"
                  sx={{
                    "& input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid2>
              <Grid2 size={3} alignContent="center">
                <TextField
                  value={data.sieveSize}
                  fullWidth
                  variant="outlined"
                  label="L/D Ratio"
                  onChange={(e) =>
                    handlesetLDRatio(data.serialNo, e.target.value)
                  }
                  type="number"
                  size="small"
                  sx={{
                    "& input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={3} alignContent="center">
                <TextField
                  value={data.compressiveStrength}
                  fullWidth
                  variant="outlined"
                  label="Compressive Strength"
                  type="number"
                  size="small"
                  onChange={(e) =>
                    handleCompressiveStrength(data.serialNo, e.target.value)
                  }
                  sx={{
                    "& input": {
                      textAlign: "right",
                    },
                  }}
                />
              </Grid2>
              {/* <Grid2 size={2} justifyItems="center">
                <Box>
                  <IconButton
                    onClick={() => handleRemoveSeleced(data.serialNo)}
                    color="error"
                    aria-label="delete"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Grid2> */}
              <Grid2 size={12} justifyItems="center">
                <Divider width="100%" />
              </Grid2>
            </Grid2>
          ))}
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default ComStrengthDrilledCoreDetails;
